module.exports = __webpack_public_path__ + "static/media/TESTIMONIALS.36867f98.jpeg";